export default __webpack_public_path__ + "static/media/b_2.ff8dbed4.jpg";